import { render, staticRenderFns } from "./BatchModifySkuSpec.vue?vue&type=template&id=58f2b94a&scoped=true"
import script from "./BatchModifySkuSpec.vue?vue&type=script&lang=js"
export * from "./BatchModifySkuSpec.vue?vue&type=script&lang=js"
import style0 from "./BatchModifySkuSpec.vue?vue&type=style&index=0&id=58f2b94a&prod&scoped=true&lang=css"
import style1 from "./BatchModifySkuSpec.vue?vue&type=style&index=1&id=58f2b94a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f2b94a",
  null
  
)

export default component.exports